import { Canvas } from 'fabric';
import { useCallback, useEffect } from 'react';

import { ToolBarTool } from './toolbar.style';
import { useDrawCanvasContext } from '../draw-canvas.context';
import ToolbarItem from './toolbar-item';
import { Tool } from 'approot/activity-builder/components/draw/canvas/draw-canvas.constants';
import IconCursorHandLight from 'approot/shared/icons/icon-cursor-hand-light';

type Props = {
  canvas?: Canvas | null;
};

const ToolbarItemCursor = ({ canvas }: Props) => {
  const { toolSet, setCursorDrawing, cursor } = useDrawCanvasContext();

  const updateCursorSettings = useCallback(
    (canvas: Canvas | null | undefined) => {
      if (canvas) {
        setCursorDrawing(canvas, cursor);
      }
    },
    [setCursorDrawing, cursor]
  );

  useEffect(() => {
    if (canvas && toolSet?.tool === Tool.Cursor) {
      updateCursorSettings(canvas);
    }
  }, [canvas, toolSet?.tool, updateCursorSettings]);

  return (
    <ToolbarItem hoverText="Move Canvas">
      <ToolBarTool
        $isActive={toolSet?.tool === Tool.Cursor}
        onClick={() => {
          updateCursorSettings(canvas);
        }}
      >
        <IconCursorHandLight width={24} height={24} />
      </ToolBarTool>
    </ToolbarItem>
  );
};
export default ToolbarItemCursor;
